import {Button} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {MessageText1} from 'iconsax-reactjs'

interface ChatViewButtonProps {
  sessionId: string
}

const ChatViewButton = ({sessionId}: ChatViewButtonProps) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  return (
    <Button
      startIcon={<MessageText1 />}
      variant="contained"
      color="primary"
      size="medium"
      sx={{marginTop: 2, borderRadius: 3}}
      onClick={() => navigate(`/chat/${sessionId}`)}
    >
      {t('fnd-assistant-button-view-chat-session')}
    </Button>
  )
}

export default ChatViewButton
